module.exports = __webpack_public_path__ + "img/presentation-app.aa017b83.png";